module.exports = __webpack_public_path__ + "static/media/chevron-left-ic.e2efe8aa.svg";